/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       SwitchOnImage.tsx
 * @author     Christian Ascone
 * @date       1/14/20 3:32 PM
 */

import React from 'react';
import {Image} from "react-native";

export function SwitchOnImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/switch_on.png')
            }
        />
    );
}